import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Instructor } from './model/instructor.model';
import { Action, createReducer, on } from '@ngrx/store';
import { InstructorActions } from './instructor.actions';

export const instructorFeatureKey = 'instructor';

export interface State extends EntityState<Instructor> {}

export const instructorAdapter: EntityAdapter<Instructor> = createEntityAdapter<Instructor>();

export const initialState: State = instructorAdapter.getInitialState({});

const instructorReducer = createReducer(
    initialState,
    on(InstructorActions.loadInstructorsSuccess, (state, { instructors }) => instructorAdapter.addMany(instructors, state))
);

export function reducer(state: State | undefined, action: Action) {
    return instructorReducer(state, action);
}
